import axios from "axios";
import { AvailabilityType } from "../enums/AvailbilityType";
import { BookingRequest } from "../domain_objects/BookingRequest";
import CrossSellSetupResponse from "../domain_objects/CrossSellSetupResponse";
import { AvailabilitySearchResponse } from "../domain_objects/AvailabilitySearchResponse";
import DateHelper from "../helpers/DateHelper";
import { BookingResponse } from "../domain_objects/BookingResponse";
import { defaultThemeStyles } from "../mocks";
import ObjectMerger from "../helpers/ObjectMerger";
import TermsAndPrivacyPolicyResponse from "../domain_objects/TermsAndPrivacyPolicyResponse";
import { GetRestaurantResponse } from "../domain_objects/GetRestaurantResponse";
import { GetRestaurantSetupResponse } from "../domain_objects/GetRestaurantSetupResponse";

export default class WidgetService {
  getWidgetSetup: (
    hostname: string,
    micrositeName: string,
    date: Date,
    themeId: number,
    channelCode: string | null
  ) => Promise<CrossSellSetupResponse> = async (
    hostname,
    micrositeName,
    date,
    themeId,
    channelCode
  ) => {
    const url = `https://${hostname}/api/Restaurant/${micrositeName}/CrossSellSetup?date=${DateHelper.getDateString(date)}&themeId=${themeId}${channelCode ? `&channelCode=${channelCode}` : ""}`;
    const response = await axios.get(url);

    if (themeId) {
      response.data.ThemeStyles = ObjectMerger.applyDefaults(
        response.data.ThemeStyles,
        defaultThemeStyles
      );
    }

    return response.data;
  };

  availabilitySearch: (
    hostname: string,
    micrositeName: string,
    date: Date,
    covers: number,
    channelCode: string,
    availabilityType: AvailabilityType,
    areaId?: number
  ) => Promise<AvailabilitySearchResponse> = async (
    hostname,
    micrositeName,
    date,
    covers,
    channelCode,
    availabilityType,
    areaId
  ) => {
    const response = await axios.get(
      `https://${hostname}/api/Restaurant/${micrositeName}/AvailabilitySearch?date=${DateHelper.getDateString(date)}&covers=${covers}&channelCode=${channelCode}&availabilityType=${availabilityType}${areaId !== undefined ? `&areaId=${areaId}` : ""}`
    );
    return response.data;
  };

  createBookingWithStripeToken: (
    hostname: string,
    micrositeName: string,
    booking: BookingRequest
  ) => Promise<BookingResponse> = async (hostname, micrositeName, booking) => {
    const response = await axios.post(
      `https://${hostname}/api/Restaurant/${micrositeName}/BookingWithStripeToken`,
      {
        ...booking,
      }
    );
    return response.data;
  };

  createBookingWithConfirmationToken: (
    hostname: string,
    micrositeName: string,
    booking: BookingRequest
  ) => Promise<BookingResponse> = async (hostname, micrositeName, booking) => {
    const response = await axios.post(
      `https://${hostname}/api/Restaurant/${micrositeName}/BookingWithConfirmationToken`,
      {
        ...booking,
      }
    );
    return response.data;
  };

  getTermsAndPrivacyPolicy: (
    hostname: string,
    micrositeName: string,
    date: Date,
    channelCode: string
  ) => Promise<TermsAndPrivacyPolicyResponse> = async (
    hostname,
    micrositeName,
    date,
    channelCode
  ) => {
    const response = await axios.get(
      `https://${hostname}/api/Restaurant/${micrositeName}/Setup?date=${DateHelper.getDateString(date)}&channelCode=${channelCode}`
    );
    return { ...response.data, MicrositeName: micrositeName };
  };

  getRestaurant: (
    hostname: string,
    micrositeName: string
  ) => Promise<GetRestaurantResponse> = async (hostname, micrositeName) => {
    const response = await axios.get(
      `https://${hostname}/api/Restaurant/${micrositeName}/`
    );
    return { ...response.data };
  };

  getRestaurantSetup: (
    hostname: string,
    micrositeName: string,
    date: Date,
    channelCode: string
  ) => Promise<GetRestaurantSetupResponse> = async (
    hostname,
    micrositeName,
    date,
    channelCode
  ) => {
    const response = await axios.get(
      `https://${hostname}/api/Restaurant/${micrositeName}/Setup?date=${DateHelper.getDateString(date)}&channelCode=${channelCode}`
    );
    return { ...response.data };
  };
}
